module.exports = __webpack_public_path__ + "static/img/right.3c610ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/right.png
// module id = VgxF
// module chunks = 0